module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "localService",
    attrs: {
      "id": "localService"
    }
  }, [_c('div', {
    staticClass: "top"
  }, [_c('h1', {
    staticClass: "bigTitle"
  }, [_vm._v("轨迹云"), _c('i', {
    staticClass: "border_bottom"
  })]), _vm._v(" "), _c('p', {
    staticClass: "underInfo"
  }, [_vm._v("一套安全、高效的集轨迹采集、轨迹存储、轨迹查询、轨迹纠偏、地理围栏、里程计算等功能为一体的云管理服务。")]), _vm._v(" "), _c('p', {
    staticClass: "underInfo",
    staticStyle: {
      "margin-top": "0"
    }
  }, [_vm._v("提供Android/iOS SDK和服务API，帮助开发者轻松构建人员、车辆轨迹追踪系统。")]), _vm._v(" "), _c('ul', {
    staticClass: "listUl"
  }, [_c('li', [_c('p', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/images/index/01.png")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "listP"
  }, [_c('span', {
    staticClass: "triangleIcon"
  }), _vm._v("提供轨迹数据上传及存储")]), _vm._v(" "), _c('p', {
    staticClass: "listP"
  }, [_c('span', {
    staticClass: "triangleIcon"
  }), _vm._v("数据上传加密压缩")]), _vm._v(" "), _c('p', {
    staticClass: "listP"
  }, [_c('span', {
    staticClass: "triangleIcon"
  }), _vm._v("支持断网续传")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/images/index/02.png")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "listP"
  }, [_c('span', {
    staticClass: "triangleIcon"
  }), _vm._v("实时轨迹位置及历史查询")]), _vm._v(" "), _c('p', {
    staticClass: "listP"
  }, [_c('span', {
    staticClass: "triangleIcon"
  }), _vm._v("支持离线轨迹纠偏")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/images/index/03.png")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "listP"
  }, [_c('span', {
    staticClass: "triangleIcon"
  }), _vm._v("支持地理围栏，越界实时报警")]), _vm._v(" "), _c('p', {
    staticClass: "listP"
  }, [_c('span', {
    staticClass: "triangleIcon"
  }), _vm._v("真实里程计算")]), _vm._v(" "), _c('p', {
    staticClass: "listP"
  }, [_c('span', {
    staticClass: "triangleIcon"
  }), _vm._v("支持轨迹驾驶行为分析")])])])]), _vm._v(" "), _c('div', {
    staticClass: "middle"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cfc8d7d2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/localService.vue
// module id = 144
// module chunks = 1